/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResultEnum = 'SUCCESS' | 'REQUESTER_NOT_ADMIN' | 'ASSOCIATED_USER_NOT_FOUND' | 'XELLENT_ERROR' | 'WOULD_LEAVE_CUSTOMER_WITHOUT_ADMIN' | 'CANNOT_REMOVE_OWN_ADMIN';

export const ResultEnum = {
    SUCCESS: 'SUCCESS' as ResultEnum,
    REQUESTERNOTADMIN: 'REQUESTER_NOT_ADMIN' as ResultEnum,
    ASSOCIATEDUSERNOTFOUND: 'ASSOCIATED_USER_NOT_FOUND' as ResultEnum,
    XELLENTERROR: 'XELLENT_ERROR' as ResultEnum,
    WOULDLEAVECUSTOMERWITHOUTADMIN: 'WOULD_LEAVE_CUSTOMER_WITHOUT_ADMIN' as ResultEnum,
    CANNOTREMOVEOWNADMIN: 'CANNOT_REMOVE_OWN_ADMIN' as ResultEnum
};

